import { makeStyles } from '@material-ui/core';
import { teal } from '@material-ui/core/colors';
import { green, neutral, orange, red } from '../../../shared/styles/colors';

export default makeStyles(() => ({
  root: ({ isInKanban }: Props) => ({
    border: isInKanban ? 0 : `1px solid ${neutral.D10}`,
    padding: isInKanban ? 0 : '1rem 0.625rem',
    borderRadius: '0.5rem',
  }),
  main: ({ isInKanban }: Props) => ({
    backgroundColor: neutral.white,
    padding: isInKanban ? '0.5rem 1rem' : 0,
    borderRadius: isInKanban ? '0.5rem' : 0,
  }),
  title: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.625rem',
    color: neutral['80'],
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: '1rem',
    letterSpacing: '1.2px',
  },
  checkCodeText: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 400,
    color: neutral['80'],
    lineHeight: '1rem',
  },
  checkCode: {
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.25rem',
    color: neutral['80'],
    borderRadius: '0.5rem',
    backgroundColor: neutral['10'],
    padding: '0.75rem 1rem',
  },
  bagsQuantityText: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 400,
    color: neutral['80'],
    lineHeight: '1rem',
  },
  quantityButton: {
    border: `1.25px solid ${neutral[20]}`,
    borderRadius: '0.42rem',
    backgroundColor: neutral['white'],
    fontSize: '1.64rem',
    fontWeight: 600,
    color: neutral[80],
    cursor: 'pointer',
    width: '2.5rem',
    height: '2.5rem',
  },
  quantityButtonDisabled: {
    borderRadius: '0.42rem',
    backgroundColor: neutral['20'],
    fontSize: '1.64rem',
    fontWeight: 600,
    color: neutral[50],
    width: '2.5rem',
    height: '2.5rem',
    cursor: 'not-allowed',
  },
  quantityText: {
    width: '1.5rem',
    textAlign: 'center',
    fontFamily: 'PP Object Sans',
    fontSize: '1.25rem',
    fontWeight: 700,
    color: neutral['80'],
    lineHeight: '1rem',
  },
  drinksText: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 400,
    color: neutral['80'],
    lineHeight: '1rem',
  },
  hasDrinksText: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: neutral['80'],
    lineHeight: '1rem',
    margin: '0 0.5rem',
  },
  radioGroupOptions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
  },
  radioRootButton: {
    margin: '0',
    flexDirection: 'row-reverse',
    '& .MuiRadio-root': {
      display: 'none',
    },
  },
  radioLabelButton: {
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 700,
    color: neutral['50'],
    lineHeight: '1rem',
    margin: '0 0.5rem',
    padding: '1rem 0.75rem',
  },
  radioLabelButtonChecked: {
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 700,
    color: neutral['100'],
    lineHeight: '1rem',
    margin: '0 0.5rem',
    padding: '1rem 0.75rem',
  },
  loading: {
    fontFamily: 'PP Object Sans',
    color: neutral.D15,
    fontSize: '0.625rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.031235rem',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  success: {
    fontFamily: 'PP Object Sans',
    color: green[60],
    fontSize: '0.625rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.075rem',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  error: {
    fontFamily: 'PP Object Sans',
    color: red[60],
    fontSize: '0.625rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.075rem',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  errorIcon: {
    color: red[40],
    fontSize: '0.75rem',
    fontWeight: 'bold',
    animationDuration: '0.5s',
    animationName: 'fadeIn',
  },
  retry: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  mandatory: {
    fontFamily: 'PP Object Sans',
    color: red[60],
    fontSize: '0.625rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: '1rem',
    letterSpacing: '1.2px',
  },
  alertMandatory: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: orange[10],
    color: neutral[80],
    padding: '0 0.75rem',
    borderRadius: '0.5rem',
    '& svg': {
      fill: orange[60],
    },
    '& .MuiAlert-icon': {
      paddingBottom: 0,
      paddingTop: 0,
    },
  },
  alertMessage: {
    fontFamily: 'PP Object Sans',
  },
  cta: {
    margin: '0.5rem 0',
    alignSelf: 'flex-end',
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  loadingButton: {
    marginRight: '0.25rem',
  },
  submitButton: ({ isInKanban }: Props) => ({
    fontFamily: 'PP Object Sans',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    border: `1px solid ${isInKanban ? teal['D5'] : neutral[90]}`,
    color: isInKanban ? neutral.white : neutral[100],
    fontSize: '0.875rem',
    fontWeight: 500,
  }),
  hasDrinksContainer: {
    display: 'flex',
    justifyContent: 'center',
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    width: '3rem',
    height: '2.5rem',
  },
  hasDrinksContainerCheked: {
    display: 'flex',
    justifyContent: 'center',
    border: `1px solid ${neutral[90]}`,
    borderRadius: '0.5rem',
    backgroundColor: neutral[10],
    width: '3rem',
    height: '2.5rem',
  },
}));

interface Props {
  isInKanban?: boolean;
}
